// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.navTable {
  width: 100%;
}

.navTable td {
  vertical-align: top;
  padding: 0 10px;
}

#candidateList {
  max-height: 240px;
  overflow-y: scroll;
}

.candidateRow {
  overflow: hidden;
}

.candidateRow table td {
  border-bottom: 1px #bcbcbc solid;
  font-size: 12px;
}

.candidateRow table.twoColumns td:first-child {
  width: 38%;
  max-width: 120px;
  word-break: break-word;
}

.noValue {
  font-style: italic;
  color: #bcbcbc;
}

.addingFooter {
  width: 97%;
  text-align: right;
  padding-top: 10px;
  margin-top: 10px;
}

.addingFooter button:first-child {
  margin-right: 10px;
}

::ng-deep .navTable .mat-form-field-infix {
  width: 100% !important;
}

::ng-deep .typeTabs .mat-tab-label {
  align-items: flex-end;
  padding: 0 12px;
  height: 37px;
}

::ng-deep .typeTabs .mat-tab-label .mat-tab-label-content {
  padding-bottom: 3px;
}

::ng-deep .typeTabs .mat-tab-body {
  padding-top: 10px;
}

.full-height {
  height: 300px;
  width: 100%;
}

.navTable .full-width {
  width: 100%;
}

.mpo-flex-column {
  display: flex;
  flex-direction: column;
}
.mpo-flex-row {
  display: flex;
  flex-direction: row;
}

.btn-search .icon-search,
.btn-search .icon-close {
  font-size: 20px;
  height: unset;
  width: unset;
  position: relative;
  top: 10px;
}`, "",{"version":3,"sources":["webpack://./src/app/analysis/graphboards/components/mobile/mobile-graphboards-person-adding/mobile-graphboards-person-adding.component.scss"],"names":[],"mappings":"AAAA;EACI,WAAA;AACJ;;AAEA;EACI,mBAAA;EACA,eAAA;AACJ;;AAEA;EACI,iBAAA;EACA,kBAAA;AACJ;;AAEA;EACI,gBAAA;AACJ;;AAEA;EACI,gCAAA;EACA,eAAA;AACJ;;AAEA;EACI,UAAA;EACA,gBAAA;EACA,sBAAA;AACJ;;AAEA;EACI,kBAAA;EACA,cAAA;AACJ;;AAEA;EACI,UAAA;EACA,iBAAA;EACA,iBAAA;EACA,gBAAA;AACJ;;AAEA;EACI,kBAAA;AACJ;;AAEA;EACI,sBAAA;AACJ;;AAEA;EACI,qBAAA;EACA,eAAA;EACA,YAAA;AACJ;;AAEA;EACI,mBAAA;AACJ;;AAEA;EACI,iBAAA;AACJ;;AAEA;EACI,aAAA;EACA,WAAA;AACJ;;AAGI;EACI,WAAA;AAAR;;AAKI;EACI,aAAA;EACA,sBAAA;AAFR;AAKI;EACI,aAAA;EACA,mBAAA;AAHR;;AAQI;;EAEI,eAAA;EACA,aAAA;EACA,YAAA;EACA,kBAAA;EACA,SAAA;AALR","sourcesContent":[".navTable {\n    width: 100%;\n}\n\n.navTable td {\n    vertical-align: top;\n    padding: 0 10px;\n}\n\n#candidateList {\n    max-height: 240px;\n    overflow-y: scroll;\n}\n\n.candidateRow {\n    overflow: hidden;\n}\n\n.candidateRow table td {\n    border-bottom: 1px #bcbcbc solid;\n    font-size: 12px;\n}\n\n.candidateRow table.twoColumns td:first-child {\n    width: 38%;\n    max-width: 120px;\n    word-break: break-word;\n}\n\n.noValue {\n    font-style: italic;\n    color: #bcbcbc;\n}\n\n.addingFooter {\n    width: 97%;\n    text-align: right;\n    padding-top: 10px;\n    margin-top: 10px;\n}\n\n.addingFooter button:first-child {\n    margin-right: 10px;\n}\n\n::ng-deep .navTable .mat-form-field-infix {\n    width: 100% !important;\n}\n\n::ng-deep .typeTabs .mat-tab-label {\n    align-items: flex-end;\n    padding: 0 12px;\n    height: 37px;\n}\n\n::ng-deep .typeTabs .mat-tab-label .mat-tab-label-content {\n    padding-bottom: 3px;\n}\n\n::ng-deep .typeTabs .mat-tab-body {\n    padding-top: 10px;\n}\n\n.full-height {\n    height: 300px;\n    width: 100%;\n}\n\n.navTable {\n    .full-width {\n        width: 100%;\n    }\n}\n\n.mpo-flex {\n    &-column {\n        display: flex;\n        flex-direction: column;\n    }\n\n    &-row {\n        display: flex;\n        flex-direction: row;\n    }\n}\n\n.btn-search {\n    .icon-search,\n    .icon-close {\n        font-size: 20px;\n        height: unset;\n        width: unset;\n        position: relative;\n        top: 10px;\n    }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
